import { useMemo } from 'react';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import CancelRounded from '@mui/icons-material/CancelRounded';
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded';

const CARD_CONTAINER_STYLE = {
  width: '100%',
  display: 'flex',
  flexWrap: 'nowrap',
  marginTop: '0px',
  marginBottom: '12px',
  gap: '10px',
  overflowX: 'auto',
  alignItems: 'stretch',
};

const CARD_STYLE = {
  flex: '1 1 0',
  minWidth: '130px',
  background: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: '5px',
  padding: '10px 12px',
  boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
  boxSizing: 'border-box',
  minHeight: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
};

const LABEL_STYLE = {
  fontSize: '12px',
  color: '#64748b',
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  minWidth: 0,
  flex: 1,
};

const VALUE_STYLE = {
  fontSize: '18px',
  fontWeight: 700,
  color: '#0f172a',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  marginLeft: '8px',
};

const STATUS_STYLES = {
  approved: {
    color: '#2e7d32',
    Icon: CheckCircleRounded,
  },
  pending: {
    color: '#e65100',
    Icon: WarningAmberRounded,
  },
  rejected: {
    color: '#e53935',
    Icon: CancelRounded,
  },
};

export default function ProductListStatCards({ products = [] }) {
  const stats = useMemo(() => {
    if (!products.length) {
      return [
        { label: 'Approved', value: 0, tone: 'approved' },
        { label: 'Merchant review pending', value: 0, tone: 'pending' },
        { label: 'Admin review pending', value: 0, tone: 'pending' },
        // { label: 'Content review pending', value: 0, tone: 'pending' },
        // { label: 'Image review pending', value: 0, tone: 'pending' },
        { label: 'Rejected', value: 0, tone: 'rejected' },
      ];
    }

    const statusCounts = products.reduce((acc, product) => {
      const status = product && product.status_type;
      if (!status) return acc;
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});

    const getCount = (statusKey) => statusCounts[statusKey] || 0;

    const rejectedCount =
      getCount('content_rejected_by_admin') +
      getCount('image_rejected_by_admin') +
      getCount('content_rejected_by_merchant') +
      getCount('image_rejected_by_merchant');

    return [
      { label: 'Approved', value: getCount('approved'), tone: 'approved' },
      {
        label: 'Merchant review pending',
        value: getCount('merchant_review_pending'),
        tone: 'pending',
      },
      { label: 'Admin review pending', value: getCount('admin_review_pending'), tone: 'pending' },
      // {
      //   label: 'Content review pending',
      //   value: getCount('merchant_content_review_pending'),
      //   tone: 'pending',
      // },
      // {
      //   label: 'Image review pending',
      //   value: getCount('merchant_image_review_pending'),
      //   tone: 'pending',
      // },
      { label: 'Rejected', value: rejectedCount, tone: 'rejected' },
    ];
  }, [products]);

  return (
    <div style={CARD_CONTAINER_STYLE}>
      {stats.map((stat, index) => {
        const statusStyle = STATUS_STYLES[stat.tone];
        const isActive = stat.value > 0 && statusStyle;
        const StatusIcon = statusStyle?.Icon;

        return (
          <div key={index} style={CARD_STYLE}>
            <div
              title={stat.label}
              style={{
                ...LABEL_STYLE,
                color: isActive ? statusStyle.color : LABEL_STYLE.color,
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer',
              }}
            >
              {isActive && StatusIcon ? (
                <StatusIcon sx={{ fontSize: 16, color: statusStyle.color }} />
              ) : null}
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                  flex: 1,
                }}
              >
                {stat.label}
              </span>
            </div>
            <div
              style={{
                ...VALUE_STYLE,
                color: isActive ? statusStyle.color : VALUE_STYLE.color,
              }}
            >
              {stat.value.toLocaleString()}
            </div>
          </div>
        );
      })}
    </div>
  );
}
